module.exports = __webpack_public_path__ + "static/media/ira.5e316c6e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/ira.svg
// module id = 3072
// module chunks = 0